'use client';

import { RefObject, useEffect, useRef, useState } from 'react';

import { apiGtm } from '../lib/apiGtm';
import { GTMPromotion } from '../utils/bannerPromotion';

interface GTMViewPromotionProps {
  refItem: RefObject<HTMLElement | null>;
  promotionIndex: number;
  getPromotion: (index: number) => GTMPromotion | undefined;
  once?: boolean;
}

export const GTMViewPromotion = ({
  refItem,
  promotionIndex,
  getPromotion,
  once = false
}: GTMViewPromotionProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const sentRef = useRef(false);

  useEffect(() => {
    const itemElement = refItem.current;
    if (!itemElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5, rootMargin: '0px' }
    );

    observer.observe(itemElement);

    return () => observer.disconnect();
  }, [refItem]);

  useEffect(() => {
    if (!isVisible) return;
    if (once && sentRef.current) return;

    const promotion = getPromotion(promotionIndex);
    if (!promotion) return;

    if (once) sentRef.current = true;

    apiGtm.viewPromotion({
      ecommerce: {
        promoView: {
          promotions: [promotion]
        }
      }
    });
  }, [getPromotion, isVisible, once, promotionIndex]);

  return null;
};
